export const getCellData = (tableData, rowID, columnID) => {
  let row;
  if (Array.isArray(tableData)) {
    row = tableData[rowID];
  } else {
    row = Array.isArray(tableData.data) ? tableData.data[rowID] : [];
  }

  let currentValue;
  if (Array.isArray(row)) {
    currentValue = row[columnID];
  } else {
    const { data } = row;
    currentValue = data[columnID];
  }
  return currentValue;
};

export const updateCellData = (tableData, rowID, colID, cellValue) => {
  if (Array.isArray(tableData.data)) {
    const currentValue = getCellData(tableData, rowID, colID);

    let updatedCell = null;
    if (currentValue && currentValue instanceof Object) {
      const { attributes } = currentValue;
      if (attributes.editable !== false) {
        updatedCell = {
          ...currentValue,
          data: cellValue,
        };
      }
    } else {
      updatedCell = cellValue;
    }
    const updatedTableData = [];
    tableData.data.forEach((currentRow, rowIndex) => {
      if (rowIndex === rowID) {
        const { data: rowData } = currentRow;
        const updatedRowData = [];
        rowData.forEach((cell, columnId) => {
          if (columnId === colID) updatedRowData.push(cell);
          else updatedRowData.push(updatedCell);
        });
        updatedTableData.push({ ...currentRow, data: updatedRowData });
      } else {
        updatedTableData.push(currentRow);
      }
    });
    return {
      ...tableData,
      data: updatedTableData,
    };
  }

  return tableData;
};

export const isTableActive = (section, activeID) => {
  const {
    data: { data: rowData },
    id,
  } = section;
  if (!Array.isArray(rowData)) return false;
  if (id === activeID) return true;
  for (let i = 0; i < rowData.length; i += 1) {
    const row = rowData[i];
    if (Array.isArray(row.data)) {
      for (let j = 0; j < row.data.length; j += 1) {
        const cell = row.data[j];
        if (cell.attributes.id === activeID) return true;
      }
    }
  }
  return false;
};
